import { appColors, Tier, formatUTCDateTimeToLocaleString } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { View, Text, StyleSheet } from '@react-pdf/renderer';

type MinimumTrackHeaderPDFProps = Readonly<{
  minimumTrack: Tier;
  fullName?: string;
  createdAt: string;
}>;

export const MinimumTrackHeaderPDF = ({
  minimumTrack,
  fullName,
  createdAt,
}: MinimumTrackHeaderPDFProps) => {
  return (
    <View style={styles.container}>
      <View style={{ ...styles.trackContainer, width: fullName ? '68%' : '100%' }}>
        <Text style={styles.bodyText}>{appStrings.modules.results.minimumTrackTitle}</Text>
        <Text style={styles.headerText}>{minimumTrack}</Text>
      </View>
      {fullName && (
        <View style={styles.dateNameContainer}>
          <Text style={styles.nameText}>{fullName}</Text>
          <Text style={styles.dateText}>{formatUTCDateTimeToLocaleString(createdAt)}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    gap: 16,
  },
  dateNameContainer: {
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: appColors.color.blue4,
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 8,
    marginBottom: 8,
    flexDirection: 'column',
    justifyContent: 'center',
    width: '32%',
  },
  trackContainer: {
    backgroundColor: appColors.neutral.white,
    border: `1px solid ${appColors.neutral.black}`,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingTop: 4,
    paddingBottom: 8,
    marginVertical: 8,
  },
  bodyText: {
    fontSize: 12,
    color: appColors.color.blue1,
  },
  headerText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  nameText: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  dateText: {
    fontSize: 10,
    color: appColors.color.blue1,
  },
});
